export namespace NoteEvents {
  export const NOTE_TEXT_ENTRY_TEXT_CHANGED: string = "note:textentry:text-changed";

}

